var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox",class:{
    'checkbox--readonly': _vm.readonly,
    'checkbox--single': _vm.single,
    'checkbox--center': _vm.center,
    'checkbox--design-new': _vm.design === 'new'
  }},[_c('span',{staticClass:"checkbox__text"},[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"checkbox__checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }